import images from "./images";

const programming = [
  {
    imgUrl: images.html,
    title: "HTML",
  },
  {
    imgUrl: images.css,
    title: "CSS",
  },
  {
    imgUrl: images.js,
    title: "JavaScript",
  },
  {
    imgUrl: images.post,
    title: "Postman",
  },
];



const backend = [
  {
    imgUrl: images.mongo,
    title: "MongoDB",
  },
  {
    imgUrl: images.express,
    title: "ExpressJs",
  },
  {
    imgUrl: images.react,
    title: "React",
  },
  {
    imgUrl: images.node,
    title: "Node.js",
  },
];

const framework = [
  {
    imgUrl: images.scss,
    title: "Sass",
  },
  {
    imgUrl: images.tail,
    title: "Tailwind.css",
  },
  {
    imgUrl: images.fire,
    title: "Google Firebase",
  },
  {
    imgUrl: images.gatsby,
    title: "Gatsbyjs",
  },
  {
    imgUrl: images.sanity,
    title: "Sanity",
  },
  {
    imgUrl: images.algolia,
    title: "algolia",
  },
];


const portfolio = [
  {
    title: "Portfolio",
    subtitle: "Few Projects I worked on"
  }
]
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { programming, backend, framework, portfolio };
